import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [createPersistedState({
      storage: window.sessionStorage,
      reducer(value) {
        return {
          userInfo: value.user,
          // menus: value.user.menu,
        };
      },
  })],
});

export default store;
